import { createAPI } from '@/request.js'
// 意见列表
export const ambitionList = data => createAPI('/api/ambition/query.mt', 'post', data)
// 处理意见
export const editAmbition = data => createAPI('/api/ambition/deal.mt', 'post', data)
